import React, { Component } from 'react';
import { connect } from 'react-redux';
// @ts-expect-error
import Filmstrip from '../../../../../modules/UI/videolayout/Filmstrip';
import { getLocalParticipant } from '../../../base/participants/functions';
import { getVerticalViewMaxWidth } from '../../../filmstrip/functions.web';
import { getToolboxHeight } from '../../../toolbox/functions.web';
import { getLargeVideoParticipant } from '../../../large-video/functions';
import VideoManager from './VideoManager';
import YoutubeVideoManager from './YoutubeVideoManager';
import IframeManager from './IframeManager';
/** .
 * Implements a React {@link Component} which represents the large video (a.k.a.
 * The conference participant who is on the local stage) on Web/React.
 *
 * @augments Component
 */
class SharedVideo extends Component {
    /**
     * Computes the width and the height of the component.
     *
     * @returns {{
     *  height: number,
     *  width: number
     * }}
     */
    getDimensions() {
        const { clientHeight, clientWidth, filmstripVisible, filmstripWidth, largeVideoUserName } = this.props;
        let width;
        let height;
        let display;
        if (interfaceConfig.VERTICAL_FILMSTRIP) {
            if (filmstripVisible) {
                width = `${clientWidth - filmstripWidth}px`;
            }
            else {
                width = `${clientWidth}px`;
            }
            height = `${clientHeight - getToolboxHeight()}px`;
        }
        else {
            if (filmstripVisible) {
                height = `${clientHeight - Filmstrip.getFilmstripHeight()}px`;
            }
            else {
                height = `${clientHeight}px`;
            }
            width = `${clientWidth}px`;
        }
        display = largeVideoUserName != "Video" ? "none" : "block";
        return {
            width,
            height,
            display
        };
    }
    /**
     * Retrieves the manager to be used for playing the shared video.
     *
     * @returns {Component}
     */
    getManager() {
        const { videoUrl } = this.props;
        if (!videoUrl) {
            return null;
        }
        if (videoUrl.match(/http/)) {
            if (this.isSharedIframeUrl(videoUrl) === false) {
                return React.createElement(VideoManager, { videoId: videoUrl });
            }
            else {
                return React.createElement(IframeManager, { videoId: videoUrl });
            }
        }
        return React.createElement(YoutubeVideoManager, { videoId: videoUrl });
    }
    /**
     * Differentiate video or iframe.
     *
     * @returns {void}
     */
    isSharedIframeUrl(videoUrl) {
        const searchValue = '/XLSharedApp_Iframe';
        return videoUrl.endsWith(searchValue);
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {React$Element}
     */
    render() {
        const { isOwner, isResizing, videoUrl } = this.props;
        const className = !isResizing && isOwner || (videoUrl && this.isSharedIframeUrl(videoUrl)) ? '' : 'disable-pointer';
        return (React.createElement("div", { className: className, id: 'sharedVideo', style: this.getDimensions() }, this.getManager()));
    }
}
/**
 * Maps (parts of) the Redux state to the associated LargeVideo props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const { ownerId, videoUrl } = state['features/shared-video'];
    const { clientHeight, clientWidth } = state['features/base/responsive-ui'];
    const { visible, isResizing } = state['features/filmstrip'];
    const localParticipant = getLocalParticipant(state);
    const largeVideoParticipant = getLargeVideoParticipant(state);
    return {
        clientHeight,
        clientWidth,
        filmstripVisible: visible,
        filmstripWidth: getVerticalViewMaxWidth(state),
        isOwner: ownerId === localParticipant?.id,
        isResizing,
        videoUrl,
        largeVideoUserName: largeVideoParticipant?.name
    };
}
export default connect(_mapStateToProps)(SharedVideo);
